import { useEffect, useState } from "react";
import React, { useRef } from "react";
import contractABI from "../../publicSmartContractABI/PublicMervCoin.json";
import { ethers } from "ethers";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import { makeStyles } from "@material-ui/core/styles";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
const useStyles = makeStyles(styles);
import SweetAlert from "react-bootstrap-sweetalert";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance"; 
const useStyleData = makeStyles(stylesData);

const ChangePublicAdmin = () => {
  const [formData, setFormData] = useState({
    toAddress: "",
    amount: "",
  });
  const [alert, setAlert] = React.useState(null);
  const navigate = useNavigate();
  useEffect(() => {});
  const handleSimple = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const transferCoin = async (e) => {
    e.preventDefault();
    console.log(
        "jjj"
    )
    try {
      const [account] = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      let contract = new ethers.Contract(
        process.env.REACT_APP_CONTRACT_ADDRESS,
        contractABI.abi,
        signer
      );
      console.log("contract",contract)
      console.log("ddd",formData.toAddress)
      let transaction = await contract
        .changeAdmin(formData.toAddress)
        .then((res) => {
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  {`Admin Changed successfully`}
                </span>
              }
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              titleCssClass={classesSweetAlert.cardTitle}
              confirmBtnCssClass={
                classesSweetAlert.button + " " + classesSweetAlert.success
              }
            />
          );
        });
    } catch (error) {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {error?.message}
            </span>
          }
          onConfirm={() => hideAlert()}
          onCancel={() => hideAlert()}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
    }
  };
  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/dashboard`);
  };
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <>
      <form onSubmit={transferCoin}>
        <h3 style={{ fontStyle: "bold" }}>
          Transfer coin to private investors on public blockchain
        </h3>
        <h4 style={{ fontWeight: 700 }}>
          Contract Address: {process.env.REACT_APP_CONTRACT_ADDRESS}
        </h4>
        <h5>New Admin Address:</h5>
        <input
          style={{
            width: "45%",
            margin: "13px 3px",
            padding: "5px 5px",
            fontFamily: "sans-serif",
            fontSize: "1vw",
            fontWeight: 700,
          }}
          id="toAddress"
          name="toAddress"
          value={formData.toAddress}
          onChange={handleSimple}
        />
        <br />
        <button
          type="submit"
          style={{
            width: "10%",
            color: "white",
            backgroundColor: "blueviolet",
            borderRadius: "6px",
            height: "41px",
            fontSize: "15px",
            fontWeight: 700,
            padding: "2px",
            cursor: "pointer",
          }}
        >
          Change Admin
        </button>
        {alert}
      </form>
    </>
  );
};

export default ChangePublicAdmin;
